export const DELETE_DRAFT_ENDPOINT = '/api/deleteDraft'
export const DRAFTS_ENDPOINT = `/${process.env.REACT_APP_API_KEY}/Drafts`
